import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import VerificationInput from 'react-verification-input';
import { Button, Input, Modal } from '../../../components';
import {
  useDispatch,
  useSelector,
  profileSlice,
  fetchCellphoneGetCode,
  fetchCellphoneValidateCode,
  fetchEditPhone,
} from '../../../stores';
import { palette } from '../../../theme';
import { handleApiReturn, handleErrors } from '../../../utils';
import {
  StyledButtonsWrapper,
  StyledInputWrapper,
  StyledStepWrapper,
  StyledTextWrapper,
} from '../styles';
import { validationCodeSchema, validationPhoneSchema } from '../validations';

export const EditPhoneModal: React.FC = () => {
  const dispatch = useDispatch();
  const { editPhoneIsOpen, phoneEditStep, editLoading } = useSelector(
    (state) => state.profileReducer,
  );
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [formData, setFormData] = useState({
    cellphone: '',
    code: '',
  });

  const handleClose = () => {
    setFormData({
      cellphone: '',
      code: '',
    });
    dispatch(profileSlice.actions.setPhoneEditStep(1));
    dispatch(profileSlice.actions.toggleEditPhoneIsOpen());
  };

  const handleRequestCode = () => {
    setErrors({});
    validationPhoneSchema
      .validate(formData, { abortEarly: false })
      .then(() =>
        dispatch(fetchCellphoneGetCode({ number: formData.cellphone })).then(
          (res: any) => {
            handleApiReturn(
              res,
              () => {
                toast.success('Código enviado para celular com sucesso.');
                dispatch(profileSlice.actions.setPhoneEditStep(2));
              },
              null,
            );
          },
        ),
      )
      .catch((err) => {
        setErrors(handleErrors(err));
      });
  };

  const handleVerifyCode = () => {
    setErrors({});
    validationCodeSchema
      .validate(formData, { abortEarly: false })
      .then(() => {
        dispatch(
          fetchCellphoneValidateCode({
            number: formData.cellphone || '',
            code: formData.code,
          }),
        ).then((res: any) => {
          handleApiReturn(
            res,
            () => {
              handleUpdatePhone();
            },
            null,
          );
        });
      })
      .catch((err) => {
        setErrors(handleErrors(err));
      });
  };

  const handleUpdatePhone = () => {
    dispatch(
      fetchEditPhone({
        driverId: localStorage.getItem('NITROT:driverId') || '',
        cellphone: formData.cellphone,
        validationCode: formData.code,
      }),
    ).then((res: any) => {
      handleApiReturn(
        res,
        () => {
          toast.success('Telefone atualizado com sucesso.');
          handleClose();
        },
        null,
      );
    });
  };

  return (
    <Modal
      open={editPhoneIsOpen}
      onClose={handleClose}
      title='Edite seu telefone'
    >
      {phoneEditStep === 1 ? (
        <StyledStepWrapper>
          <StyledTextWrapper>
            <Typography
              color='primary'
              textAlign='center'
              variant='h6'
              gutterBottom
            >
              Olá, motorista!
            </Typography>
            <Typography
              color={palette.text.main}
              textAlign='center'
              gutterBottom
            >
              Digite seu telefone para enviarmos um SMS com um código de
              validação
            </Typography>
          </StyledTextWrapper>
          <StyledInputWrapper>
            <Input
              name='cellphone'
              type='text'
              mask='phone'
              label='Telefone'
              margin='normal'
              value={formData.cellphone}
              onChange={(value: string) =>
                setFormData({ ...formData, cellphone: value })
              }
              maxLength={15}
              errorMessage={errors.cellphone}
              style={{ width: '100%' }}
            />
          </StyledInputWrapper>
          <StyledButtonsWrapper>
            <Button
              variant='contained'
              label='Validar telefone'
              type='submit'
              onClick={handleRequestCode}
              color='secondary'
              loading={editLoading}
              style={{ width: '100%' }}
            />
          </StyledButtonsWrapper>
        </StyledStepWrapper>
      ) : (
        <StyledStepWrapper>
          <StyledTextWrapper>
            <Typography
              color='primary'
              textAlign='center'
              variant='h6'
              gutterBottom
            >
              Código enviado com sucesso!
            </Typography>
            <Typography
              color={palette.text.main}
              textAlign='center'
              gutterBottom
            >
              Por favor, digite o código de 6 dígitos que enviamos por SMS para
              o seu telefone
            </Typography>
          </StyledTextWrapper>
          <StyledInputWrapper>
            <VerificationInput
              validChars='0-9'
              inputProps={{ inputMode: 'numeric' }}
              onChange={(e) => setFormData({ ...formData, code: e })}
            />
            <Typography
              color={palette.error.main}
              textAlign='center'
              gutterBottom
              marginTop={1}
              height={10}
            >
              {errors.code}
            </Typography>
          </StyledInputWrapper>
          <StyledButtonsWrapper>
            <Button
              variant='contained'
              label='Enviar'
              type='submit'
              onClick={handleVerifyCode}
              color='secondary'
              loading={editLoading}
              style={{ width: '100%' }}
            />
          </StyledButtonsWrapper>
        </StyledStepWrapper>
      )}
    </Modal>
  );
};
